export const INIT_OPTIONS_API_KEY_EXPECTED =
  "init(options): expected object with apiKey prop";
export const SET_DEVICEID_STRING_EXPECTED =
  "setUserDevice(deviceId): expected string for deviceId";
  export const SET_USERID_STRING_EXPECTED =
  "setUser(userId): expected string or null for userId";
export const SET_USERINFO_OBJECT_EXPECTED =
  "setUserInfo(properties): expected object for properties";
export const SET_GROUPINFO_GROUP_TYPE_STRING_EXPECTED =
  "setGroupInfo(groupType, groupName): expected string for groupType";
export const SET_GROUPINFO_GROUP_NAME_STRING_EXPECTED =
  "setGroupInfo(groupType, groupName): expected string for groupName";
export const LOG_EVENT_TYPE_STRING_EXPECTED =
  "log(eventType, eventProperties): expected string for eventType";
export const LOG_EVENT_PROPERTIES_OBJECT_EXPECTED =
  "log(eventType, eventProperties): expected object for eventProperties";

export const ECOMMERCE_FREE_TRIAL_VIEWED = "Ecommerce - free_trial_viewed";
export const ECOMMERCE_PRODUCT_LIST_VIEWED = "Ecommerce - product_list_viewed";
export const ECOMMERCE_PRODUCT_SELECTED = "Ecommerce - product_selected";
export const ECOMMERCE_CHECKOUT_VIEWED = "Ecommerce - checkout_viewed";
export const ECOMMERCE_PAYMENT_SUCCESS = "Ecommerce - payment_success";
export const ECOMMERCE_PAYMENT_FAILED = "Ecommerce - payment_failed";
export const ECOMMERCE_ALREADY_SUBSCRIBED = "Ecommerce - already_subscribed";
export const ECOMMERCE_THANK_YOU_VIEWED = "Ecommerce - thank_you_viewed";
export const ECOMMERCE_START_USING_CLICKED = "Ecommerce - start_using_clicked";
export const ECOMMERCE_SUBSCRIPTION_ACTIVATION_SUCCESS =
  "Ecommerce - subscription_activation_success";
export const NAVIGATION_CLICKED = "Navigation Item - clicked";

export const AMPLITUDE_MIRROR_INSTANCE_NAME = "MIRROR";
